module.exports = __webpack_public_path__ + "static/img/clear-out-the-stigmas-and-stereotypes.bc7aa39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/clear-out-the-stigmas-and-stereotypes.png
// module id = aQiX
// module chunks = 0